var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDpk1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #c9c9c9;\n        stroke: #c9c9c9;\n        stroke-miterlimit: 10;\n        stroke-width: .2px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m4.49,9.27H.85v11.37h3.63c3.71,0,6.02-2.17,6.02-5.66s-2.31-5.71-6.02-5.71Zm4.07,5.71c0,2.57-1.45,3.99-4.07,3.99h-1.71v-8.05h1.71c2.62,0,4.07,1.44,4.07,4.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m15.63,9.27h-3.76v11.37h1.92v-4.54h1.84c2.96,0,4.01-1.76,4.01-3.4s-1.05-3.43-4.01-3.43Zm2.06,3.43c0,1.16-.67,1.73-2.06,1.73h-1.84v-3.49h1.84c1.4,0,2.06.56,2.06,1.76Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "24.26 14.97 29.41 9.27 26.95 9.27 22.82 13.91 22.82 9.27 20.9 9.27 20.9 20.64 22.82 20.64 22.82 16.09 26.93 20.64 29.47 20.64 24.26 14.97"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 30,
    height: 30
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDpk1);
export default __webpack_public_path__ + "static/media/dpk-1.a98402cb9bbdf20d3d9385a8bab9dca1.svg";
export { ForwardRef as ReactComponent };